import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const ViewVendorModal = ({ show, onHide, vendor }) => {
    if (!vendor) return null;

    const formatValue = (value) => {
        return value || 'N/A';
    };

    return (
        <Modal show={show} onHide={onHide} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>
                    <i className="ri-eye-line me-2"></i>
                    Vendor Details
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                <div className="row">
                    {/* Logo Preview */}
                    {(vendor.Uploadlogo || vendor.logoUpload) && (
                        <div className="col-12 text-center mb-4">
                            <img
                                src={vendor.Uploadlogo || vendor.logoUpload}
                                alt="Vendor Logo"
                                style={{ maxHeight: '100px', maxWidth: '200px', borderRadius: 8, border: '1px solid #eee' }}
                                className="img-fluid"
                            />
                        </div>
                    )}

                    {/* Basic Information */}
                    <div className="col-12">
                        <h6 className="mb-3 text-primary border-bottom pb-2">Basic Information</h6>
                    </div>

                    <div className="col-md-6 mb-3">
                        <strong>Vendor Name:</strong>
                        <div className="text-muted">{formatValue(vendor.PartnerName)}</div>
                    </div>

                    <div className="col-md-6 mb-3">
                        <strong>Registration Number:</strong>
                        <div className="text-muted">{formatValue(vendor.RegistrationNumber)}</div>
                    </div>

                    <div className="col-md-6 mb-3">
                        <strong>VAT Number:</strong>
                        <div className="text-muted">{formatValue(vendor.VatNumber)}</div>
                    </div>

                    {/* Contact Information */}
                    <div className="col-12 mt-4">
                        <h6 className="mb-3 text-primary border-bottom pb-2">Contact Information</h6>
                    </div>

                    <div className="col-md-6 mb-3">
                        <strong>Contact Number:</strong>
                        <div className="text-muted">
                            <i className="ri-phone-line me-1"></i>
                            {formatValue(vendor.ContactNumber)}
                        </div>
                    </div>

                    <div className="col-md-6 mb-3">
                        <strong>Email:</strong>
                        <div className="text-muted">
                            <i className="ri-mail-line me-1"></i>
                            {vendor.Email ? (
                                <a href={`mailto:${vendor.Email}`} className="text-decoration-none">
                                    {vendor.Email}
                                </a>
                            ) : (
                                'N/A'
                            )}
                        </div>
                    </div>

                    <div className="col-md-6 mb-3">
                        <strong>Purchasing Manager:</strong>
                        <div className="text-muted">
                            <i className="ri-user-line me-1"></i>
                            {formatValue(vendor.PartnerManager)}
                        </div>
                    </div>

                    <div className="col-12 mb-3">
                        <strong>Address:</strong>
                        <div className="text-muted">
                            <i className="ri-map-pin-line me-1"></i>
                            {formatValue(vendor.Address)}
                        </div>
                    </div>

                    {/* Banking Details */}
                    {(vendor.BankName || vendor.AccountNumber || vendor.SortCode || vendor.IBAN || vendor.SWIFT) && (
                        <>
                            <div className="col-12 mt-4">
                                <h6 className="mb-3 text-primary border-bottom pb-2">Banking Details</h6>
                            </div>

                            <div className="col-md-6 mb-3">
                                <strong>Bank Name:</strong>
                                <div className="text-muted">{formatValue(vendor.BankName)}</div>
                            </div>

                            <div className="col-md-6 mb-3">
                                <strong>Account Number:</strong>
                                <div className="text-muted">{formatValue(vendor.AccountNumber)}</div>
                            </div>

                            <div className="col-md-6 mb-3">
                                <strong>Sort Code:</strong>
                                <div className="text-muted">{formatValue(vendor.SortCode)}</div>
                            </div>

                            <div className="col-md-6 mb-3">
                                <strong>IBAN:</strong>
                                <div className="text-muted">{formatValue(vendor.IBAN)}</div>
                            </div>

                            <div className="col-md-6 mb-3">
                                <strong>SWIFT:</strong>
                                <div className="text-muted">{formatValue(vendor.SWIFT)}</div>
                            </div>
                        </>
                    )}

                    {/* Additional Information */}
                    {vendor.RemarksNote && (
                        <>
                            <div className="col-12 mt-4">
                                <h6 className="mb-3 text-primary border-bottom pb-2">Additional Information</h6>
                            </div>

                            <div className="col-12 mb-3">
                                <strong>Remarks/Notes:</strong>
                                <div className="text-muted bg-light p-3 rounded">
                                    {vendor.RemarksNote}
                                </div>
                            </div>
                        </>
                    )}

                    {/* Metadata */}
                    {(vendor.createdAt || vendor.updatedAt) && (
                        <>
                            <div className="col-12 mt-4">
                                <h6 className="mb-3 text-primary border-bottom pb-2">Record Information</h6>
                            </div>

                            {vendor.createdAt && (
                                <div className="col-md-6 mb-3">
                                    <strong>Created At:</strong>
                                    <div className="text-muted">
                                        <i className="ri-calendar-line me-1"></i>
                                        {new Date(vendor.createdAt).toLocaleDateString('en-GB', {
                                            day: '2-digit',
                                            month: '2-digit',
                                            year: 'numeric',
                                            hour: '2-digit',
                                            minute: '2-digit'
                                        })}
                                    </div>
                                </div>
                            )}

                            {vendor.updatedAt && (
                                <div className="col-md-6 mb-3">
                                    <strong>Last Updated:</strong>
                                    <div className="text-muted">
                                        <i className="ri-calendar-line me-1"></i>
                                        {new Date(vendor.updatedAt).toLocaleDateString('en-GB', {
                                            day: '2-digit',
                                            month: '2-digit',
                                            year: 'numeric',
                                            hour: '2-digit',
                                            minute: '2-digit'
                                        })}
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ViewVendorModal;
